import { CrossOriginValidator } from '../Security';
import { WrongBubble } from './MessageEventService.types';
import { WindowEvent } from '../WindowEvent/WindowEvent';
export class MessageEventService {
    constructor(origins, originService = new CrossOriginValidator(origins), logger = console) {
        this.origins = origins;
        this.originService = originService;
        this.logger = logger;
        this.isValid = (data) => !(!data.messageOrigin || data.messageOrigin !== 'BRANCH-MF');
    }
    isSecure(origin) {
        return this.originService.isValid(origin);
    }
    tryParse(event) {
        const model = new WindowEvent();
        try {
            const { data } = event;
            if (!this.isValid(data)) {
                return WrongBubble;
            }
            if (!this.isSecure(event.origin)) {
                this.logger.log(`not secure ${event.origin}`);
                return WrongBubble;
            }
            const { payload } = data;
            model.topic = payload.topic;
            model.origin = payload.origin;
            model.data = payload.data;
        }
        catch (e) {
            this.logger.error(e);
            return WrongBubble;
        }
        return model;
    }
}
//# sourceMappingURL=MessageEventService.js.map